export const communityColors = ["#b2ebf2", "#c8e6c9", "#fff9c4", "#d7ccc8", "#cfd8dc", "#c5cae9", "#f8bbd0", "#bbdefb", "#ffe0b2"];
export const languageColors = { en: "#1EA5E1", jp: "#3F51B5" };